module.exports = __webpack_public_path__ + "static/previews-b3e899c274e24d250b9ada934e693662.mp4";